export default {
  title: {
    en: 'It\'s a flash sale! <br class="onlyMobile" />',
  },
  left: {
    en: '&nbsp;left',
  },
  text: {
    en: `
      A deal this good won’t last forever. Score our 
      <strong>{title}</strong> for a cool 
      <span class="brandColor">{price}</span> while you can. We did the math, and that’s 
      <span class="brandColor">{discount}</span> off the retail value.
    `,
  },
  buttonTitle: {
    en: 'I want this deal',
  },
  discount: {
    en: '54% off',
  },
  oppositeLink: {
    female: {
      en: 'Shop women’s flash sale',
    },
    male: {
      en: 'Shop men’s flash sale',
    },
  },
}
